import React from 'react'
import { Redirect, Route, Switch, useRouteMatch } from 'react-router-dom';
import LoginRequireRoute from '../routes/LoginRequireRoute';
import MobileLogin from '../components/auth/MobileLogin';
import LoginOtp from '../components/auth/loginOtp';
import PaymentDetails from './PaymentDetails';
import GetAndVerifyPaymentOtp from './GetAndVerifyPaymentOtp';
import PaymentScreen from '../lib/paymentScreen';
import { USER_ROLES } from '../utils/constant';
import PaymentProtectedRoute from '../routes/PaymentProtectedRoute';

export default function PaymentRouter(): JSX.Element {
    const { path } = useRouteMatch();

    return (
        <Switch>
            <Route
                exact
                path={path}
                render={(props: any) => (
                    <Redirect to={`${path}/:paymentId/payment-login`} from={props.location.state} />
                )}
            />
            {/* <Route path={`${path}/:paymentId/payment-login`} component={MobileLogin} /> */}
            <Route path={`${path}/:paymentId/payment-verify-pan`} component={LoginOtp} />
            {/* <PaymentProtectedRoute path={`${path}/:paymentId/payment-details`} component={PaymentDetails} acceptedRoles={[USER_ROLES.INVESTOR]} /> */}
            <Route path={`${path}/:paymentId/payment-login`} component={PaymentDetails} />
            {/* <PaymentProtectedRoute path={`${path}/:paymentId/validatePaymentOtp`} component={GetAndVerifyPaymentOtp} acceptedRoles={[USER_ROLES.INVESTOR]} /> */}
            <Route path={`${path}/:paymentId/validatePaymentOtp`} component={GetAndVerifyPaymentOtp} />
            <PaymentProtectedRoute path={`${path}/:paymentId/payment`} render={(props: any) => <PaymentScreen {...props} customProp="spacing" />} acceptedRoles={[USER_ROLES.INVESTOR]} />
            {/* <Route path={`${path}/:paymentId/payment`} render={(props: any) => <PaymentScreen {...props} customProp="spacing" />} /> */}
            <LoginRequireRoute path="*" />
        </Switch>
    );
}
